import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Ribbon from "@/components/site/Ribbon";
import About from "@/components/site/About";
import MenuSection from "@/components/site/MenuSection";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Reservations from "@/components/site/Reservations";
import Contacts from "@/components/site/Contacts";
import Footer from "@/components/site/Footer";
import StickyBar from "@/components/site/StickyBar";

export default function Home() {
  useEffect(() => {
    document.title = "Bar Ristorante Gabri | Ristorante di mare a Cavi di Lavagna";
  }, []);

  return (
    <div className="bg-bone">
      <Navbar />
      <main>
        <Hero />
        <Ribbon />
        <About />
        <MenuSection />
        <Gallery />
        <Reviews />
        <Reservations />
        <Contacts />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}
